import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import WhySection from "./components/WhySection";
import ImpactSection from "./components/ImpactSection";
import FounderSection from "./components/FounderSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ContactModal from "./components/ContactModal";
import FeaturedPostSection from "./components/FeaturedPostSection";
import MetricsBar from "./components/MetricsBar";
import TestimonialSection from "./components/TestimonialSection";
import { BlogPage, BlogPostPage } from "./components/BlogPage";
import AdminDashboard from "./components/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

// Landing page component
function LandingPage({ onOpenContact }) {
  return (
    <main>
      <HeroSection onOpenContact={onOpenContact} />
      <MetricsBar />
      <FounderSection />
      <AboutSection />
      <ServicesSection />
      <WhySection />
      <ImpactSection />
      <FeaturedPostSection />
      <TestimonialSection />
      <CTASection onOpenContact={onOpenContact} />
      <Footer />
    </main>
  );
}

// Blog post wrapper to get slug from params
function BlogPostWrapper() {
  const { slug } = useParams();
  return <BlogPostPage slug={slug} />;
}

// Layout wrapper that conditionally shows navigation
function AppLayout({ children, onOpenContact, isContactOpen, closeContact }) {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdminPage && <Navigation onOpenContact={onOpenContact} />}
      {children}
      {!isAdminPage && <ContactModal isOpen={isContactOpen} onClose={closeContact} />}
      <Toaster />
    </>
  );
}

function App() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openContact = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);

  return (
    <div className="min-h-screen bg-void text-white overflow-x-hidden">
      <BrowserRouter>
        <AppLayout 
          onOpenContact={openContact} 
          isContactOpen={isContactOpen} 
          closeContact={closeContact}
        >
          <Routes>
            <Route path="/" element={<LandingPage onOpenContact={openContact} />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostWrapper />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AppLayout>
      </BrowserRouter>
    </div>
  );
}

export default App;
